<template>
    <div v-if="loaded || !error" class="preview-image"
         :style="{backgroundImage: 'url(\'' + imgURL + '\')', height: '100%', backgroundSize: '100% 100%'}"
         @click="showMedia()">
    </div>
    <div v-else class="preview-image"
         :style="{backgroundImage: 'url(\'' + (isThumbnail ? '/storage/thumb/fallback' : '/storage/preview/fallback') + '\')', height: '100%', backgroundSize: '100% 100%'}">
    </div>
</template>

<script>
    import {RELOAD_IMAGE_TIMEOUT} from "./consts";
    const DEBUG = false;

    export default {
        props: ['previewUrl', 'isThumbnail', 'type', 'name', 'showModal'],
        data: function () {
            return {
                loaded: false,
                error: false,
                timeout: null,
                timeoutCount: 0
            }
        },
        computed: {
            imgURL: function() {
                let rnd = Math.ceil(Math.random() * (200 - 100) + 100);
                return this.error ? this.previewUrl + '_' + rnd : this.previewUrl;
            }
        },
        watch: {
            element: function () {
                if(this.timeout) clearTimeout(this.timeout);
                this.timeoutCount = 0;

                this.loadPreview();
            }
        },
        methods: {
            loadPreview() {
                if (this.loaded) return;
                if (!this.imgURL) return;

                if (DEBUG) console.log(`Loading preview ${this.name}, try number ${this.timeoutCount}`);
                this.timeoutCount++;

                const img = new Image();
                img.src = this.imgURL;

                img.onload = () => {
                    this.$nextTick(() => {
                        if (DEBUG) console.log(`Loading preview ${this.name} - Success!`);
                        this.loaded = true;
                    });
                }

                img.onerror = () => {
                    if (DEBUG) console.log(`Loading preview ${this.name} - Errored!`);
                    this.error = true;

                    if (this.timeoutCount < RELOAD_IMAGE_TIMEOUT.length) {
                        this.timeout = setTimeout(() => {
                            this.loadPreview();
                        }, RELOAD_IMAGE_TIMEOUT[this.timeoutCount]);
                    }
                }

                this.$forceUpdate();
            },
            showMedia: function () {
                if (this.showModal === true) {
                    let url = this.previewUrl
                    let mime = this.type === 'video' ? 'video/mp4' : 'image/jpg';

                    if(this.isThumbnail) {
                        if (this.type === 'video') {
                            url = url.replace('/thumb', '').replace('.jpg', '');
                        } else if (this.type === 'campaign') {
                            url = url.replace('/thumb', '/original');
                        } else {
                            url = url.replace('/thumb', '');
                        }
                    }

                    EaseEventBus.fire('showMedia', {
                        mime_type: mime,
                        original: url,
                        display_name: this.name
                    });
                }
            },
        },
        mounted: function () {
            this.loadPreview();
        }
    }
</script>
